import axios from "axios";
import { toast } from "sonner";
import { API } from "@/lib/api";

export const PARTNER_IMG = {
  hero: "https://images.pexels.com/photos/3285193/pexels-photo-3285193.jpeg",
  oldHome: "https://images.unsplash.com/photo-1663625318264-695d2d04f11a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxtb3ZpbmclMjBkYXklMjBjYXJkYm9hcmQlMjBib3hlcyUyMGVtcHR5JTIwcm9vbXxlbnwwfHx8fDE3ODc2Nzk2Nzd8MA&ixlib=rb-4.1.0&q=85",
  workshop: "https://images.pexels.com/photos/5095271/pexels-photo-5095271.jpeg",
  newHome: "https://images.unsplash.com/photo-1728649060658-8e64dccf2711?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxlbGVnYW50JTIwbmV3JTIwaG9tZSUyMGxpdmluZyUyMHJvb20lMjBuYXR1cmFsJTIwbGlnaHR8ZW58MHx8fHwxNzg3Njc5Njc2fDA&ixlib=rb-4.1.0&q=85",
};

export const PROSPECT_STATUSES = [
  "Researching", "Ready to Contact", "Contacted", "Presentation Viewed", "Interested",
  "Call Booked", "Partner", "Activated", "Not Interested", "Follow Up Later",
];

export const PARTNER_STATUSES = ["Prospect", "Partner", "Activated"];

export const PROSPECT_STYLES = {
  Researching: "bg-gray-100 text-gray-600",
  "Ready to Contact": "bg-blue-50 text-blue-700",
  Contacted: "bg-indigo-50 text-indigo-700",
  "Presentation Viewed": "bg-amber-50 text-amber-800",
  Interested: "bg-[#c19a6b]/20 text-[#8a6a42]",
  "Call Booked": "bg-purple-50 text-purple-700",
  Partner: "bg-emerald-50 text-emerald-700",
  Activated: "bg-emerald-600 text-white",
  "Not Interested": "bg-red-50 text-red-600",
  "Follow Up Later": "bg-gray-200 text-gray-500",
};

export const sessionId = () => {
  let v = localStorage.getItem("ark_sid");
  if (!v) {
    v = crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    localStorage.setItem("ark_sid", v);
  }
  return v;
};

export const trackPartner = (slug, event_type, metadata = {}) =>
  axios
    .post(`${API}/public/partners/${slug}/event`, { event_type, session_id: sessionId(), metadata })
    .catch(() => {});

export const money0 = (cents) =>
  new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD", maximumFractionDigits: 0 }).format((cents || 0) / 100);

export const dollars0 = (v) =>
  new Intl.NumberFormat("en-CA", {
    style: "currency",
    currency: "CAD",
    maximumFractionDigits: (v || 0) >= 1000000 ? 1 : 0,
    notation: (v || 0) >= 1000000 ? "compact" : "standard",
  }).format(v || 0);

export const timeAgo = (iso) => {
  if (!iso) return "—";
  const mins = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins} min ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs} hour${hrs === 1 ? "" : "s"} ago`;
  const days = Math.round(hrs / 24);
  if (days < 31) return `${days} day${days === 1 ? "" : "s"} ago`;
  return new Date(iso).toLocaleDateString("en-CA", { month: "short", day: "numeric", year: "numeric" });
};

export const shortDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-CA", { month: "short", day: "numeric", year: "numeric" }) : "—";

export const copyText = (text, label = "Copied") => {
  navigator.clipboard.writeText(text);
  toast.success(label);
};

export const eventText = (e) => {
  const name = e.metadata?.name || "A client";
  const amount = e.metadata?.amount_cents ? ` — ${money0(e.metadata.amount_cents)}` : "";
  switch (e.event_type) {
    case "presentation_view": return "Viewed their partnership presentation for the first time";
    case "presentation_repeat_view": return "Returned to their partnership presentation";
    case "client_preview_view": return "Previewed their client page";
    case "activation_click": return "Clicked Activate My Client Benefit";
    case "activation_complete": return "Activated their client program";
    case "call_cta_click": return "Clicked Book a 10-Minute Call";
    case "copy_client_link": return "Copied their client link";
    case "download_qr": return "Downloaded their QR code";
    case "download_card": return "Downloaded their digital client card";
    case "qr_scan": return "QR code scanned";
    case "client_page_view": return "A client visited their client page";
    case "quote_view": return `${name} opened their quote${amount}`;
    case "quote_start": return "A client started a revival request";
    case "lead_submit": return `${name} submitted a revival request`;
    case "quote_created": return `ARK created a quote for ${name}${amount}`;
    case "quote_complete": return `${name} received an invoice${amount}`;
    case "sale": return `${name} became a customer${amount}`;
    default: return e.event_type.replace(/_/g, " ");
  }
};
